<template>
    <ModalBase @close="cancel" :withContent="true" v-show="visible">
        <h1>{{ $trad.plano.renameFavoriteModal.title }}</h1>
        <main><TextInputBloc :label="'Nom'" :min-length="3" :required="true" v-model="label"></TextInputBloc></main>
        <footer>
            <ClientColorButton :disabled="$v.label.$invalid" @click="validate();">{{ $trad.common.ok }}</ClientColorButton>
            <ClientColorButton :inactive-color="true" @click="cancel();">{{ $trad.common.cancel }}</ClientColorButton>
        </footer>
    </ModalBase>
</template>

<script>
import ModalBase from "@/components/modal/ModalBase";
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import ClientColorButton from "@/components/ui/ClientColorButton";
import TextInputBloc from "@/components/ui/Form/TextInputBloc";
import { MAX_LENGTH_NAME, MIN_LENGTH_NAME } from "@/utils/string";

let renameFavoriteWidget;
window.renameFavorite = function renameFavorite(data, onValidate, onCancel) {
    renameFavoriteWidget.getBuilder = () => data.builder;
    renameFavoriteWidget.label = data.label;
    renameFavoriteWidget.visible = true;
    renameFavoriteWidget.onValidate = onValidate;
    renameFavoriteWidget.onCancel = onCancel;
};

export default {
    components: { ModalBase, ClientColorButton, TextInputBloc },
    data: () => ({
        label: "",
        visible: false,
        onValidate: undefined,
        onCancel: undefined
    }),
    created() {
        renameFavoriteWidget = this;
    },
    validations: {
        label: {
            required,
            max: maxLength(MAX_LENGTH_NAME),
            min: minLength(MIN_LENGTH_NAME)
        }
    },
    methods: {
        validate() {
            this.onValidate({
                label: this.label
            });
            this.visible = false;
            this.$emit("rename", this.getBuilder());
        },
        cancel() {
            this.onCancel();
            this.visible = false;
        }
    }
};
</script>

<style scoped lang="scss">
main {
    margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// rename_favorite.vue?1b35ed3c